import React, { Component } from "react";

interface Props {
    id: string;
    label: string;
    changed?: boolean;
}

class Tab extends Component<Props> {
    public render() {
        return (
            <div className="tab-pane active">
                <div className="panel-body">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Tab;


// WEBPACK FOOTER //
// ./src/components/Tab/Tab.tsx